const EmbedSupportScript = () => {
  // This script listens for messages from embedded iframes to resize themselves
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
  // Queue messages until React hydration completes to prevent hydration mismatches
  let isHydrated = false;
  const messageQueue = [];

  function beehiiv_messageHandler(event) {
    if (event.data && event.data.type === 'beehiiv:iframe_height') {
      if (!isHydrated) {
        // Queue message until hydration completes
        messageQueue.push(event);
        return;
      }

      let iframe = null;

      // Try embedId first (works for sandboxed iframes in editor)
      if (event.data.embedId) {
        iframe = document.getElementById(event.data.embedId);
        if (iframe) {
          // The embed div contains the iframe, so find it
          iframe = iframe.querySelector('iframe');
        }
      }

      // Fallback to frameElement (works for non-sandboxed iframes on published sites)
      if (!iframe && event.source) {
        try {
          iframe = event.source.frameElement;
        } catch (e) {
          // frameElement access fails for sandboxed iframes (cross-origin)
        }
      }

      if (iframe && event.data.height) {
        iframe.style.height = event.data.height + 'px';
      }
    }
  }

  window.addEventListener('message', beehiiv_messageHandler);

  // Wait for React hydration to complete before processing queued messages
  // Listen for custom event dispatched after hydration completes
  document.addEventListener('beehiiv:hydration_completed', () => {
    isHydrated = true;
    messageQueue.forEach(event => beehiiv_messageHandler(event));
    messageQueue.length = 0;
  });
  `,
      }}
    />
  );
};

export default EmbedSupportScript;
